import apiFetch from '@wordpress/api-fetch';

export default class DownloadsFilter {
  constructor() {
    this.form = document.querySelector('.downloads-filter__form');

    if (this.form) {
      this.init();
    }
  }

  init() {
    //add listener to form
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.getDownloads();
    });

    //add listeners to all selects and inputs
    this.form.querySelectorAll('select, input').forEach((input) => {
      input.addEventListener('change', () => this.getDownloads());
    });
  }

  getDownloads() {
    const formData = new FormData(this.form);

    fetch(
      `/wp-json/wp/v2/downloads?search=${formData.get(
        's'
      )}&_fields=acf,download-filter,id`
    )
      .then((r) => r.json())
      .then((r) => {
        //filter results
        const results = r
          .filter((download) => {
            let use = true;

            if (formData.get('related_serre')) {
              use = !Array.isArray(download.acf.related_serre)
                ? download.acf.related_serre ===
                  parseInt(formData.get('related_serre'))
                : download.acf.related_serre.includes(
                    parseInt(formData.get('related_serre'))
                  );
            }

            if (formData.get('download-filter') && use) {
              use = download['download-filter'].includes(
                parseInt(formData.get('download-filter'))
              );
            }

            return use;
          })
          .map((result) => result.id);

        //show or hide downloads
        document
          .querySelectorAll('.downloads-filter__downloads .download-item')
          .forEach((downloadElem) => {
            const id = parseInt(downloadElem.dataset.id);

            if (results.includes(id)) {
              //show
              downloadElem.classList.remove('inActive');
            } else {
              //hide
              downloadElem.classList.add('inActive');
            }
          });
      });
  }
}
